/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PscListResponse as ModelsPscListResponse } from '../../models/models/psc-list-response';

export interface ApiV1BorCompaniesCompanyIdPscGet$Params {

/**
 * Company ID
 */
  companyId: number;
}

export function apiV1BorCompaniesCompanyIdPscGet(http: HttpClient, rootUrl: string, params: ApiV1BorCompaniesCompanyIdPscGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsPscListResponse>> {
  const rb = new RequestBuilder(rootUrl, apiV1BorCompaniesCompanyIdPscGet.PATH, 'get');
  if (params) {
    rb.path('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsPscListResponse>;
    })
  );
}

apiV1BorCompaniesCompanyIdPscGet.PATH = '/api/v1/bor/companies/{companyId}/psc';
